import Resource from './resource'

export class ApiCampaign extends Resource {
  get campaignKind(): number {
    return this.get('campaign_kind')
  }

  get campaignAppKind(): 'novelty' | 'game' | 'game_coupon' {
    return this.get('campaign_app_kind')
  }
}
